/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TwoFactorVerificationResult } from '../../models/two-factor-verification-result';
import { TwoFactorVerifyRequest } from '../../models/two-factor-verify-request';

export interface Verify2fa$Params {
  authorization: string;
      body: TwoFactorVerifyRequest
}

export function verify2fa(http: HttpClient, rootUrl: string, params: Verify2fa$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorVerificationResult>> {
  const rb = new RequestBuilder(rootUrl, verify2fa.PATH, 'post');
  if (params) {
    rb.header('authorization', params.authorization, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TwoFactorVerificationResult>;
    })
  );
}

verify2fa.PATH = '/auth/2fa/verify';
